import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { styleMap } from 'lit/directives/style-map.js';
import SmallHelpers from '@/utils/SmallHelpers';

@customElement('team-color-swatch')
export class TeamColorSwatch extends LitElement {
    static readonly styles = css`
        :host {
            display: block;
            height: 100%;
        }
        .swatch {
            width: 100%;
            height: 100%;
            border-radius: 3px;
            border: 2px solid var(--swatch-border-color, #e0e0e0);
            box-sizing: border-box;
        }
    `;

    @property({ type: String }) color: string = '';

    private readonly _smallHelpers = new SmallHelpers();

    render() {
        return html`
            <div class="swatch" style=${styleMap(this._smallHelpers.getTeamColor(this.color))}></div>
        `;
    }
}

export default TeamColorSwatch;
